/* 
 * Custom Jquery for this theme
 */

jQuery(function ($) {

  __window = $(window);
  __body = $('body');
  __header = $('header');
  __footer = $('footer');


  __winwidth = __window.width();
  __winheight = __window.height();

  /* For iOS touch hover effect */
  document.addEventListener("touchstart", function () { }, false);

  if (jQuery('#custom-select').length > 0) {
    jQuery("#custom-select").selectmenu();
  }

  if (jQuery('#custom-select1').length > 0) {
    jQuery("#custom-select1").selectmenu();
  }

  if (jQuery('#bottom-search').length > 0) {
    jQuery("#bottom-search").selectmenu({
      change: function (event, ui) {
        window.location.href = this.value;
      }
    });
  }

  if (jQuery('#select-one').length > 0) {
    jQuery("#select-one").selectmenu();
  }

  if (jQuery('#select-two').length > 0) {
    jQuery("#select-two").selectmenu();
  }

  if (jQuery('#select-three').length > 0) {
    jQuery("#select-three").selectmenu();
  }

  if (jQuery('#select-four').length > 0) {
    jQuery("#select-four").selectmenu();
  }

  if (jQuery('#select-five').length > 0) {
    jQuery("#select-five").selectmenu();
  }

  if (jQuery('#select-six').length > 0) {
    jQuery("#select-six").selectmenu();
  }

  if (jQuery('#select-seven').length > 0) {
    jQuery("#select-seven").selectmenu();
  }

  if (jQuery('#select-eight').length > 0) {
    jQuery("#select-eight").selectmenu();
  }

  if (jQuery('#accordion').length > 0) {
    jQuery("#accordion").accordion({ heightStyle: "content" });
  }

  if (jQuery('#accordion-faq').length > 0) {
    jQuery("#accordion-faq").accordion({ heightStyle: "content" });
  }

  if (jQuery('#accordion-faq1').length > 0) {
    jQuery("#accordion-faq1").accordion({ heightStyle: "content", collapsible: true, active: false });
  }

  if (jQuery('.banner-section .swiper-container').length > 0) {
    var swiper = new Swiper('.banner-section .swiper-container', {
      /*effect: 'fade',*/
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.banner-section .swiper-button-next',
        prevEl: '.banner-section .swiper-button-prev',
      },
    });
  }
  if (jQuery('.banner-section.contact-banner .swiper-container').length > 0) {
    if (__winwidth > 767) {
      var swiper = new Swiper('.banner-section.contact-banner .swiper-container', {
        /*effect: 'fade',*/
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.banner-section.contact-banner .swiper-button-next',
          prevEl: '.banner-section.contact-banner .swiper-button-prev',
        },
      });
    }
  }

  jQuery('body').on('click', '.search-icon', function () {
    jQuery(this).next().slideToggle();
  });
  jQuery('body').on('click', '.menu-icon', function () {
    jQuery('header').toggleClass("menu-open");
  });
  jQuery(document).mouseup(function (e) {
    var container = jQuery('.mobile-menu ul, .menu-icon');
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      jQuery('header').removeClass("menu-open");
    }
  });

  if (__winwidth < 768) {
    jQuery('.account-section .left-sidebar').click(function (s) {
      s.preventDefault();
      //jQuery(this).siblings().closest('.right-account-details').find('.left-sidebar').next().addClass('fjfjf');
      jQuery(this).siblings().closest('.right-account-details').find('.left-sidebar').removeClass('active');
      jQuery(this).addClass('active');
      jQuery(this).siblings().closest('.right-account-details').find('.for-hide-mobile').slideUp();
      jQuery(this).next().slideDown();
    });
  }

  //Smooth scroll
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $href = $.attr(this, 'href');
    $el = $($href);

    if ($el.length > 0) {
      $('html, body').animate({
        scrollTop: $el.offset().top
      }, 500);
    }
  });

});

jQuery(window).on('load', function () {


});

jQuery(window).on('load resize', function () {

  __window = jQuery(window);
  __winwidth = __window.width();

  __container__width = jQuery('.container').outerWidth();

  __image__width = jQuery('.offer-section .inner-offer-col').outerWidth();
  __left__position = (__winwidth - __image__width) / 2;
  __left__position = __left__position - 20;


  if (__winwidth < 768) {
    jQuery('.offer-section .inner-offer-col').css('margin-right', -__left__position);
    jQuery('.offer-section .inner-offer-col').css('margin-left', -__left__position);
  }

  if (jQuery('.destaques-section .swiper-container').length > 0) {
    var swiper = new Swiper('.destaques-section .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 22,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.destaques-section .swiper-button-next',
        prevEl: '.destaques-section .swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 4,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        767: {
          spaceBetween: 22,
        }
      }
    });
  }

  if (jQuery('.destaques-section.not-active-slider .swiper-container').length > 0) {
    var swiper = new Swiper('.destaques-section.not-active-slider .swiper-container', {
      slidesPerView: 4,
      spaceBetween: 5,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.destaques-section.not-active-slider .swiper-button-next',
        prevEl: '.destaques-section.not-active-slider .swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 5
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        // when window width is >= 640px
        767: {
          slidesPerView: 4,
          spaceBetween: 5
        }
      }
    });
  }

  if (jQuery('.inner-impecavel-slider .swiper-container').length > 0) {
    var swiper = new Swiper('.inner-impecavel-slider .swiper-container', {
      effect: 'coverflow',
      grabCursor: 'true',
      centeredSlides: 'true',
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 118,
        modifier: 3,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.inner-impecavel-slider .swiper-button-next',
        prevEl: '.inner-impecavel-slider .swiper-button-prev',
      },
    });
  }

  if (jQuery('.inner-impecavel-slider-gallery .gallery-thumbs').length > 0) {
    var galleryThumbs = new Swiper('.inner-impecavel-slider-gallery .gallery-thumbs', {
      slidesPerView: 3,
      freeMode: true,
      loop: 'true',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
  }
  if (jQuery('.inner-impecavel-slider-gallery .gallery-top').length > 0) {
    var galleryTop = new Swiper('.inner-impecavel-slider-gallery .gallery-top', {
      spaceBetween: 0,
      loop: 'true',
      navigation: {
        nextEl: '.inner-impecavel-slider-gallery .swiper-button-next',
        prevEl: '.inner-impecavel-slider-gallery .swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }

  if (jQuery('.product-descrip-section .gallery-thumbs, .grand-taste-top-section .gallery-thumbs').length > 0) {
    var galleryThumbs = new Swiper('.product-descrip-section .gallery-thumbs, .grand-taste-top-section .gallery-thumbs', {
      spaceBetween: 7,
      slidesPerView: 3,
      freeMode: true,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
  }
  if (jQuery('.product-descrip-section .gallery-top, .grand-taste-top-section .gallery-top').length > 0) {
    var galleryTop = new Swiper('.product-descrip-section .gallery-top, .grand-taste-top-section .gallery-top', {
      spaceBetween: 2,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.product-descrip-section .swiper-button-next, .grand-taste-top-section .swiper-button-next',
        prevEl: '.product-descrip-section .swiper-button-prev, .grand-taste-top-section .swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }
});
